import { WeekDay } from '../menu/enums.types';
import { OrientationType, StellarPlaylist } from './playlist.types';
export interface ScreenResponse {
  count: number;
  screens: ScreenData[];
}
export interface ScreenData {
  id: number;
  name: string;
  liveNow: string[];
  status: string;
  orientation?: ScreenOrientation;
}

export interface ImgAndVideoUrls {
  url: string;
  type: string;
}

export interface ScreenPlaylistItem {
  id: number;
  name: string;
  duration: string;
  imgAndVideoUrls: ImgAndVideoUrls[];
  sortOrder: number;
  schedule: PremStateType;
  orientation: OrientationType;
}
export interface PremStateType {
  channelVisibilityType: string;
  device: string;
  isDefault: boolean;
  isVisible: boolean;
  scheduling: {
    allDay: boolean;
    day: string;
    endTime: string;
    id: null;
    startTime: string;
  }[];
}

export interface FindSettingResponse {
  id: number;
  name: string;
  orientation: ScreenOrientation;
}

export interface Schedule {
  allDay: boolean;
  day: WeekDay;
  endTime: string;
  id: null | number;
  startTime: string;
}

export enum ScreenOrientation {
  Zero = '0',
  Nighty = '90',
  OneEighty = '180',
  TwoSeventy = '270',
}

export interface SelectedImage {
  url: string;
  id: number;
  name: string;
}
export interface ScheduleModal {
  show: boolean;
  index: number;
}
export interface DeletePlaylistPayload {
  id: number | undefined;
  playlistId: number;
  restaurantId: number | undefined;
}
export interface HandleEditScreenSetting {
  name: string;
  orientation: ScreenOrientation;
}

export interface ScreenPlaylists {
  businessLogo: string | null;
  playlists: StellarPlaylist[];
  orientation: ScreenOrientation;
  tenantId: number;
  restaurantTimings?: Timing[];
}

export interface Timing {
  day: string;
  startTime: string;
  endTime: string;
}

export interface RestaurantTiming {
  day: string;
  startTime: string;
  endTime: string;
}

export interface ScreenPayload {
  serialNumber?: string; // serial number
  businessId?: number;
  restaurantId?: number;
}

export interface TvPlaylist {
  schedules: any;
  id: number;
  name: string;
  sortOrder: number;
  items: {
    id: number;
    name: string;
    duration: string;
    imageUrl: string;
    type: string;
    sortOrder: number;
    playlistType: string | undefined;
    template: any;
  }[];
}
